import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Building2, CheckCircle, Clock, XCircle, Ban } from 'lucide-react';

interface TenantStats {
  total: number;
  active: number;
  trial: number;
  suspended: number;
  cancelled: number;
}

interface TenantStatusCardsProps {
  stats: TenantStats | undefined;
  isLoading?: boolean;
}

export function TenantStatusCards({ stats, isLoading }: TenantStatusCardsProps) {
  const cards = [
    {
      title: 'Total Clientes',
      value: stats?.total || 0,
      icon: Building2,
      color: 'text-foreground',
    },
    {
      title: 'Ativos',
      value: stats?.active || 0,
      icon: CheckCircle,
      color: 'text-green-500',
    },
    {
      title: 'Trial',
      value: stats?.trial || 0,
      icon: Clock,
      color: 'text-blue-500',
    },
    {
      title: 'Suspensos',
      value: stats?.suspended || 0,
      icon: Ban,
      color: 'text-yellow-500',
    },
    {
      title: 'Cancelados',
      value: stats?.cancelled || 0,
      icon: XCircle,
      color: 'text-red-500',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-5">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            <card.icon className={`h-4 w-4 ${card.color}`} />
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <Skeleton className="h-8 w-16" />
            ) : (
              <div className={`text-2xl font-bold ${card.color}`}>{card.value}</div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
